<template>
    <header>
        <!--Title Page-->
        <div class="p-12 header-page">
            <div class="centerY">
                <div class="btn-icon-custom mr-8" @click="goToScenario">
                    <img src="/img/debug/arrow-left.svg" alt="icon-back" style="width: 24px">
                </div>
                <div style="line-height: 21px;">
                    <div class="title-page">{{ $f.tc('debugMode') }}</div>
                    <div class="sub-title">{{ scenario.name }} {{ callLogActivated ? ` / ${callLogActivated.id}` : '' }}
                    </div>
                </div>
            </div>
            <v-spacer></v-spacer>
        </div>
        <!--List monitoring variables-->
        <div class="monitoring-bar centerY scrollbar-horizontal-thin">
            <!-- Button clear all monitoring variables -->
            <div v-if="monitoringVars.length > 0" class="btn-clear-all" @click="clearAllMonitoringVars">
                {{ $f.tc('clearAll') }}
            </div>
            <!-- Button add new monitoring variables -->
            <div>
                <v-menu
                    v-model="showAddMonitoringVar"
                    :close-on-content-click="false"
                    :nudge-width="280"
                    nudge-bottom="8"
                    offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <div class="btn-add-monitoring centerY mr-6" v-on="on">
                            <div class="icon-add-monitoring"></div>
                            <div>{{ $f.tc('addMonitoring') }}</div>
                        </div>
                    </template>
                    <v-card>
                        <div class="p-12">
                            <div class="centerY">
                                <div style="width: 360px">
                                    <v-autocomplete
                                        :items="variables"
                                        :placeholder="`${$f.tc('enter')} ${$t('monitoringVariable')}`"
                                        class="input-custom mr-6"
                                        v-model="variablesSelected"
                                        spellcheck="false"
                                        hide-details
                                        multiple
                                        clearable
                                    >
                                        <template v-slot:item="{ item }">
                                            <v-checkbox
                                                :id="item"
                                                color="#0052CC"
                                                :value="variablesSelected.includes(item)"
                                                :label="item"
                                            ></v-checkbox>
                                        </template>
                                        <template v-slot:selection="{ item }">
                                        </template>
                                    </v-autocomplete>
                                </div>
                                <div class="btn-custom" @click="addNewMonitoring">
                                    {{ $f.tc('addNew') }}
                                </div>
                            </div>
                            <div>
                                <div v-if="!variablesSelected || variablesSelected.length === 0" class="no-data-des">
                                    {{ $f.tc('noVariableSelected') }}
                                </div>
                                <div v-else class="list-vars mt-6">
                                    <div v-for="(variable, idx) in variablesSelected" :key="`variable_monitor_${idx}`" class="chip">
                                        {{ variable }}
                                        <img
                                            src="/img/debug/close-circle_grey.svg"
                                            alt="icon-close"
                                            style="cursor: pointer; width: 16px"
                                            @click="() => variablesSelected.splice(idx, 1)"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </v-menu>
            </div>
            <!-- List monitoring variables -->
            <div class="centerY" style="gap: 6px" v-if="monitoringVars.length > 0">
                <div class="tag-item centerXY" v-for="monitoringItem in monitoringVars"
                     :key="monitoringItem">
                    {{ monitoringItem }}
                    <img src="/img/debug/close-circle.svg" alt="icon-close"
                         @click="deleteMonitoringVar(monitoringItem)">
                </div>
            </div>
        </div>
    </header>
</template>
<script>
import {mapState} from "vuex";
import CampaignService from '@/services/campaign.service'

export default {
    name: 'DebugHeader',
    data() {
        return {
            variablesSelected: [],
            showAddMonitoringVar: false
        }
    },
    computed: {
        ...mapState({
            scenario: state => state.scenario.scenario,
            variableList: state => state.debug.variables,
            callLogActivated: state => state.debug.callLogActivated,
            monitoringVars: state => state.debug.monitoringVariables
        }),
        variables () {
            return this.variableList.filter(item => !this.monitoringVars.includes(item))
        }
    },
    beforeDestroy() {
        this.$store.commit(this.$actionTypes.debug.MONITORING_VARIABLES, [])
    },
    methods: {
        goToScenario() {
            this.$router.push(`/scenarios/${this.scenario.id}`)
        },
        addNewMonitoring() {
            this.$store.commit(this.$actionTypes.debug.ADD_MONITORING_VARS, this.variablesSelected)
            this.showAddMonitoringVar = false
        },
        deleteMonitoringVar(monitoringVar) {
            this.$store.commit(this.$actionTypes.debug.DELETE_MONITORING_VAR, monitoringVar)
        },
        clearAllMonitoringVars() {
            this.$appService.confirm(this.$t('confirmClearAllMonitoringVars')).then(
                () => {
                    this.$store.commit(this.$actionTypes.debug.MONITORING_VARIABLES, [])
                }
            )
        }
    },
    watch: {
        showAddMonitoringVar(newVal) {
            if (newVal) {
                this.variablesSelected = []
            }
        }
    }
}
</script>

<style scoped lang="scss">
.header-page {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #EFEFEF;
    background: #FFFFFF;

    .title-page {
        font-family: "open sans semi", serif;
        font-size: 18px;
        color: #545253;
        text-transform: capitalize;
    }

    .sub-title {
        font-size: 13px;
        color: #9A9A9A;
    }
}

.monitoring-bar {
    border-bottom: 1px solid #EFEFEF;
    padding: 8px 12px;
    background: #FFFFFF;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    .tag-item {
        padding: 0 6px 0 8px;
        height: 25px;
        line-height: 25px;
        background: #EAEEFF;
        color: #0052CC;
        border-radius: 4px;
        font-size: 13px;
        font-family: "open sans", serif;

        img {
            cursor: pointer;
            width: 18px;
            margin-left: 3px;
        }
    }
}

.btn-add-monitoring, .btn-clear-all {
    padding: 3px 8px;
    cursor: pointer;
    border-radius: 5px;
    justify-content: center;
    color: #818181;
    white-space: nowrap;
    font-family: "open sans", serif;
    font-size: 13px;
    background: #EFEFEF;

    &:hover {
        background: #0052CC;
        color: #FFFFFF;
        transition: 0.3s;

        .icon-add-monitoring {
            background-image: url("/img/debug/add-box_white.svg");
        }
    }
}

.no-data-des {
    color: #9A9A9A;
    font-size: 13px;
    margin-top: 6px;
    font-family: "open sans", serif;
}

.list-vars {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    width: 451px;
    
    .chip {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 3px 8px;
        border-radius: 5px;
        white-space: nowrap;
        font-family: "open sans", serif;
        font-size: 13px;
        background: #EFEFEF;
        color: #818181;
    }
}

.btn-clear-all {
    background: #dc3545 !important;
    color: #FFFFFF !important;
    margin-right: 6px;
    cursor: pointer;
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
    
    .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 0 !important;
    }
    
    .v-list__tile__action {
        min-width: 30px !important;
    }
    
    .v-input--selection-controls {
        margin-top: 11px !important;
        padding-top: 0 !important;
    }
    
    label {
        font-family: "open sans", serif !important;
        font-size: 14px !important;
        color: #545253;
    }
}
</style>
